import { getWeek, getYear } from "date-fns";

export const getPlatformVersion = () => {
  return (
    localStorage?.getItem("comvel-platform-version") ??
    `${getWeek(new Date())}${getYear(new Date())}`
  );
};
